module.exports = __webpack_public_path__ + "static/media/nature.462ac6ad.jpg";